/***
 * Created on 2023/8/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../hook/pre_check_password";
import {formatDate} from "../../../../service/datetime";
import {useTogglePopup} from "common/Hook";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../../service/api";


function SMSPanel({secure, label, dispatch, state}) {
    const { t } = useTranslation();
    const {isShow, toggleAction, elemRef} = useTogglePopup();
    const {checkPassword} = usePreCheckPassword();

    const onUpdate = async () => {
        const opts = {
            method: label,
            action: 'update'
        }
        await checkPassword({
            onSuccess: ()=>dispatch({type: 'toggleAddPhone', value: true, opts}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleAddPhone', opts})
        });
    }

    const onRemove = async () => {
        const opts = {
            method: label,
            action: 'delete',
            qid: secure[label]?.phone_number
        }
        await checkPassword({
            onSuccess: () => dispatch({type: 'toggleRemoveMethod', value: true, opts}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleRemoveMethod', opts})
        });
    }

    return (
        <div className="comp-content-wrapper comp-content-wrapper--phone-list">
            <div className="two-step--setting__row">
                <div className="two-step--setting__row__col-left">
                    <div className="two-step--setting__method two-step--setting__method-text"></div>
                </div>
                <div className="two-step--setting__row__col-center">
                    <div className="text-15 font-medium !pt-4 !pb-4">
                        {secure[label].country_code} {secure[label].phone_number}
                    </div>
                    <div className="color-dark-gray">
                        {t('@Added on:@')} {formatDate(t, secure[label]?.added_on, true)}
                    </div>
                </div>
                <div className="two-step--setting__row__col-right">
                    <div className={`util-btn ${isShow ? 'active' : ''}`} util-type="more" color-scheme="normal" onClick={toggleAction} ref={elemRef}>
                        <div className="comp-dropdown menu-comfortable menu-align-right" data-modal-sheet>
                            <ul className="dropdown-menu">
                                <li className="dropdown-menu__item cursor-pointer" onClick={onUpdate}>{t('@Change Phone@')}</li>
                                {
                                    (secure?.google_auth || secure?.qnap_auth) && <li className="dropdown-menu__item cursor-pointer color-red" onClick={onRemove}>{t('@Remove Phone@')}</li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


function TwoStepOptions({dispatch, state}) {
    const { t } = useTranslation();
    const {checkPassword} = usePreCheckPassword();

    const user = useQuery({
        queryKey: ['profile'],
        queryFn: async () => {
            const resp = await apiGet('/ajax/profile');
            localStorage.setItem('currentUser', JSON.stringify(resp));
            return resp;
        },
        refetchOnWindowFocus: false,
    })

    const addAnotherPhone = async () => {
        const opts = {
            method: user?.data?.secure?.sms_1 ? 'sms_2' : 'sms_1',
            action: 'update'
        }
        await checkPassword({
            onSuccess: ()=>dispatch({type: 'toggleAddPhone', value: true, opts}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleAddPhone', opts})
        });
    }

    useEffect(() => {
        user.refetch()
        // queryClient.invalidateQueries({queryKey: ["profile"]});
    }, [state.refreshSMSPanel]);

    return (
        <section className="two-step--setting">
            <header>{t('@Alternative Phone (SMS)@')}</header>

            {user?.data?.secure?.sms_1  && <SMSPanel secure={user?.data?.secure} label={'sms_1'} dispatch={dispatch}/>}

            {!user?.data?.secure?.sms_1 &&
                <div className="comp-content-wrapper comp-content-wrapper--phone-setup">
                    <div className="two-step--setting__row">
                        <div className="two-step--setting__row__col-left">
                            <div className="two-step--setting__method two-step--setting__method-text"></div>
                        </div>
                        <div className="two-step--setting__row__col-center">
                            <div className="text-15 font-medium !pt-4 !pb-4">{t('@Text Message@')}</div>
                            <div className="color-dark-gray">
                                {t('@Receiving verification code from SMS, Not Recommen@')}
                            </div>
                        </div>
                        <div className="two-step--setting__row__col-right">
                            <button className="q-btn q-btn--default btn-small btn-rounded-full"  onClick={addAnotherPhone}>
                                <span className="q-btn__label">{t('@Set up@')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </section>
    );
}

export default TwoStepOptions;